<template>
  <div v-show="isCreateInvoiceModalVisible">
    <div class="modal-mask" @click="closeModal">
      <div class="modal-container" @click.stop v-if="loading == false">

                    <div class="modal-header"> </div> 

                    <!-- Modal body -->
                    <div class="modal-body" style="color: #858585;">

                      <div class="form-group row">
                          <div class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12" style="padding-left: 15px;">
                            <b>Purchase using an invoice?</b>
                            <div style="padding-top: 2px">
                              License(s) will be added once payment has been received.
                            </div>
                          </div>
                      </div>
                      <div class="col-12 p-0" style="margin-top: 30px;">
                        <div class="col-6 p-0 float-left" style="text-align: left;">
                          <button type="submit" class="btn btn-sm closeBtn" @click="closeModal">Cancel</button>
                        </div>
                        <div class="col-6 p-0 float-left" style="text-align: right;">
                          <button type="submit" class="btn btn-md ma-blue-btn" @click="onSubmit">Create Invoice</button>
                        </div>
                      </div>

                    </div>
     
    </div>
</div>
</div>
</template>

<script>
import Vue from 'vue/dist/vue.esm';
import axios from 'axios';

export default {
  props: [
    'isCreateInvoiceModalVisible',  
    ],
  data() {
    return {
      loading: false,
    }
  },
  methods: {
    closeModal() {
          this.$emit('close');
    },
    onSubmit() {
       this.$parent.isCreateInvoiceModalVisible = false;
       this.$parent.processPayment();       
    },
  },
}
</script>

<style scoped>
.modal-mask {
  position: fixed;
  z-index: 9998;
  top: 0;
  left: 0;
  margin: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, .5);
  transition: opacity .3s ease;
  overflow-y: scroll;
}
.modal-container {
  position: fixed;
  left: 50%;
  top: 50%;
  -ms-transform: translate(-50%, -50%);
  -moz-transform: translate(-50%, -50%);
  -webkit-transform: translate(-50%, -50%);
  transform: translate(-50%, -50%);
  width: 500px;
  height: auto;
  overflow-y: auto;
  padding: 20px 30px;
  background-color: #fff;
  border-radius: 2px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, .33);
  transition: all .3s ease;
}
.modal-body {
  margin: 0px;
  padding: 10px;
}
.modal-header .sub-heading {
  background-color: #FFF;
  color: #555;
}
.modal-header {
  padding: 5px;
}
.modal-header .close {
  margin: -1.5rem -2rem -1rem auto;
}
.history-table-wrapper {
  height: 350px;
  overflow-y: auto;
}
.modal-footer {
  border-top: none;
}
.modal-title {
  font-size: 14px;
  font-weight: 900;
}
.modal-header {
  border-bottom: 0px;
  margin-bottom: 10px;
}
.modal-body {
  padding: 5px;
}
.closeBtn {
  width: 110px;
}
.form-control { font-size: 14px; }
.hide_vmessage {
  display: none !important;
}
.show_vmessage {
  display: block !important;
}
@media (min-width: 320px) and (max-width: 991px) { 
  .modal-container {
    width: 100%;
  }
}
</style>


// WEBPACK FOOTER //
// src/components/manager/create_invoice_confirm_modal.vue